<template>
  <v-container text-xs-center mt-5>
    <h3
      v-if="showLink"
      id="helpLink"
      class="font-weight-regular white--text"
      @click="onHelpClick"
    >
      {{ $t('help.needHelp')}}
    </h3>
    <v-img class="mx-auto" width="35" height="28" src="@/assets/art/Wifi_Graphic.svg" />
    <h3 class="font-weight-regular white--text">{{$t('webTransfer.connectToWifi')}} <span class="font-weight-bold">Walmart Wi-Fi.</span></h3>
  </v-container>
</template>

<script>
export default {
  name: 'HelpItem',
  props: {
    showLink: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    onHelpClick () {
      const routeToHelp = this.$router.resolve({ name: 'Help' })
      // open in a new tab
      window.open(routeToHelp.href, '_blank')
    }
  }
}
</script>

<style>
#helpLink {
  cursor: pointer;
  margin-bottom: 30px;
  text-decoration: underline;
}
</style>
